// extracted by mini-css-extract-plugin
export default {"Dialog":"GlobalUserNavDrawer-module__Dialog--NKXRq","anchor":"GlobalUserNavDrawer-module__anchor--ZzsiJ"};